import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ApiService} from "@netfoundry-ui/shared/services";
import _ from "lodash";

@Component({
    selector: 'lib-item-selector',
    templateUrl: './item-selector.component.html',
    styleUrls: ['./item-selector.component.scss'],
    standalone: false
})
export class ItemSelectorComponent implements OnChanges {

  @Input() currentItem: any = {};
  @Input() items: any[] = [];
  @Input() isOpened = false;
  @Input() filterString = '';
  @Input() showAddNewItem = true;
  @Input() showManageItems = true;
  @Input() showHeader = true;
  @Input() addNewItemLabel = 'Add a New Network';
  @Input() manageItemsLabel = 'Manage Networks';
  @Input() manageItemsLink = '/networks';
  @Input() alwaysOpen = false;
  @Output() goToManageItems: EventEmitter<any> = new EventEmitter();
  @Output() currentItemChange: EventEmitter<any> = new EventEmitter();
  @Output() filterStringChange: EventEmitter<any> = new EventEmitter();
  @Output() addNewItem: EventEmitter<any> = new EventEmitter();

  constructor(public apiService: ApiService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.resetSelected();
  }

  resetSelected() {
    this.items.forEach((listItem) => {
      listItem.selected = this.currentItem?.id === listItem.id;
    });
  }

  toggleList(event: any) {
    if (this.alwaysOpen) {
      this.isOpened = true;
      event.stopPropagation();
      return;
    }
    this.isOpened = !this.isOpened;
    event.stopPropagation();
    return false;
  }

  stopProp(event: any) {
    event.stopPropagation();
  }

  itemSelected(item: any) {
    this.currentItemChange.emit(item);
    this.resetSelected();
    item.selected = true;
    this.closeItemList();
  }

  addNetItemSelected(event: any) {
    this.addNewItem.emit(event);
    this.closeItemList();
  }

  manageItemsSelected(event: any) {
    this.isOpened = false;
    this.goToManageItems.emit(event);
    this.closeItemList();
  }

  handleClickOutside(event: any) {
    this.closeItemList();
  }

  openList() {
    this.isOpened = true;
  }

  closeItemList() {
    if (this.alwaysOpen) {
      this.isOpened = true;
      return;
    }
    this.isOpened = false;
  }
}
